import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ICurrentTable {
  currentTable: string;
}

const initialState: ICurrentTable = {
  currentTable: "",
};

const currentTableSlice = createSlice({
  name: "currentTable",
  initialState,
  reducers: {
    setCurrentTable: (state, action: PayloadAction<string>) => {
      state.currentTable = action.payload;
    },
    initCurrentTable: (state) => {
      state.currentTable = "";
    },
  },
});

export const { setCurrentTable } = currentTableSlice.actions;
export default currentTableSlice.reducer;
